module.exports = __webpack_public_path__ + "static/fonts/iconfont.6f52ff90.eot";